import api from '../utils/api';
import { normalizeApiResponse } from '../utils/apiResponseHandler';

const tablePreferencesService = {
  // Get column order for a specific table
  getColumnOrder: async (tableName) => {
    try {
      const response = await api.get(`/table-preferences/${tableName}/order`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Get column visibility for a specific table
  getColumnVisibility: async (tableName) => {
    try {
      const response = await api.get(`/table-preferences/${tableName}/visibility`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Update table preferences (both columnOrder and columnVisibility)
  updateTablePreferences: async (tableName, preferences) => {
    try {
      console.log('tablePreferencesService.updateTablePreferences called:', {
        tableName,
        preferences,
        url: `/table-preferences/${tableName}`
      });
      const response = await api.put(`/table-preferences/${tableName}`, preferences);
      console.log('API response:', response);
      return normalizeApiResponse(response);
    } catch (error) {
      console.error('API error in updateTablePreferences:', error);
      throw error;
    }
  },
};

export default tablePreferencesService;
